import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Combobox } from '@flywire/react-headlessui';
import { useFieldClasses } from '../Field';
const FieldComponent = forwardRef(({ className, ...rest }, ref) => {
    const fieldClasses = useFieldClasses({ className });
    return _jsx(Combobox.Field, { className: fieldClasses, ref: ref, ...rest });
});
FieldComponent.displayName = 'Field';
const Field = FieldComponent;
export { Field };
//# sourceMappingURL=Field.js.map